// extracted by mini-css-extract-plugin
export default {"default_button":"styles_default_button__Apd1E","second_button":"styles_second_button__01lZ1"};